export default {
    'delete-message': 'هل أنت متأكد من أنك تريد حذف نوع المهمة هذا ؟'
}